import React, { useEffect } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { useUpdateCartMutation } from './CartApi';
import { CART_REMOVE_ALL_SELLER_ITEMS } from './cartUtils';

const CartCleaner = props => {
  const { currentUser, pageData, clearCart } = props;
  const [updateCart, { error }] = useUpdateCartMutation();

  const processClearCart = () => {
    if (!clearCart) return;
    const items = pageData?.orderData?.cart?.items || [];
    const authorId = items[0]?.authorId;
    if (authorId) {
      const listing = { id: { uuid: null }, author: { id: { uuid: authorId } } };
      updateCart({ currentUser, listing, action: CART_REMOVE_ALL_SELLER_ITEMS });
    }
  };

  useEffect(processClearCart, [clearCart]); // eslint-disable-line

  return error ? (
    <div><FormattedMessage id="CheckoutPage.cartCleanerError" /></div>
  ) : null;
};

export default CartCleaner;
